import React from 'react';
import compose from './Util';
import Form from 'reactstrap/lib/Form';
import Field from "@gqlapp/forms-client-react/FieldAdapter";
import BaseConfig from "@xem/look/utils/fieldConfig";
import Button from 'reactstrap/lib/Button'
import clsx from "clsx";
import getField from "@xem/custom-page-client-react/components/form/field";

export default compose((props: any) => {
	let { items, handleSubmit, submitProps } = props;
	let { onActions, setFieldValue, values } = props;
	let tabIndex = 1, obj = { onActions, setFieldValue, values }

	return (<div {...props}>
		<Form onSubmit={handleSubmit}>
			{(items || []).map(({ type, ...rest}, key)=> {
				const C = getField(type);

				Object.assign(rest, obj, { submitProps, tabIndex });
				tabIndex++;
				return React.createElement(C, rest);
			})}
		</Form>
	</div>);
});